/* ==================FORMAT=========================
	1. All Keys should have first letter as Capitals
	2. Values can be a String or Array. Nothing else
*/

export const DSTV = {
	"Title": "DSTV",
	"Description": "Hello, you can pay your DSTV bill here.",
	"Packages": [
		"The available packages are:",
		'Compact, (#6100)',
		'Prem XtraView (#16,140)',
		'Premium (#14080)',
		'Compact plus (#9520)',
		'Access(#1900)',
		'Family (#3700)',
		'Premium Dual (#16240)',
		'Compact+ PVR (#11680)',
		'Compact +HD (#8160)',
		'Compact+ Xtra (#11680)',
		'Premium HD (#15880)',
		'Mobile Mini (#700)',
		'Mobile Maxi (#890)'
	],
	"How": [
	'Ask Kudi. You can ask Kudi in any of these ways or similar:',
	'Pay my DSTV bill',
	'I need DSTV subscription',
	'Recharge my DStv bill'
	],
	"Charge": "The charge fee for this transaction is 100 naira."
};

export const GOTV = {
	"Title": "GOTV",
	"Description": "Hello, you can pay your GOTV bill here. The available packages are:",
	"packages": [
		"The available packages are:",
		'Plus (#1900)',
		'Value (#1300)',
		'Mobile (#650)',
		'Lite (#650)'
	],
	"How": [
		'Ask Kudi. You can ask Kudi in any of these ways or similar:',
		'Pay my GOTV bill',
		'Recharge my GOTV bill',
		'Recharge GOTV lite for me',
		'GOTV'
	],
	"Charge": 'The charge fee for this transaction is 100 naira.'
};

export const PHCN = {
	"Title": "PHCN",
	"Description": "Hello, you can pay for your electricity bill here. The available discos are:",
	"Packages": [
		'The available discos are:',
		'Eko electric',
		'Ikeja electric',
		'Abuja electric',
		'Kano electric'
	],
	"How": [
		'Ask Kudi. You can ask Kudi in any of these ways or similar:',
		'Pay electricity bill',
		'I want to pay for PHCN'
	],
	"Charge": 'The charge fee for this transaction is 100 naira.'
};

export const TRANSFER = {
	"Title": "TRANSFER",
	"Description": "Hello, you can transfer your money here.",
	"Limits": [
		'The Transfer limits are stated below:',
		'The maximum transfer limit per transaction is 200,000 and minimum is 500',
		'The maximum transfer limit for a day is 500,000'
	],
	"How": [
		'Ask Kudi. You can ask Kudi in any of these ways or similar:',
		'Transfer 50,000 to Bola',
		'Transfer 50k',
		'I want to transfer money',
		'Transfer 100k to (account number)'
	],
	"Charge": 'FREE!'
};

export const AIRTIME = {
	"Title": "AIRTIME",
	"Description": "Airtel, Etisalat, Glo and MTN airtime only are available.",
	"Price": [
		'Below is the Pricing information:',
		'Minimum airtime you can buy is #50 and maximum is #15,000'
	],
	"How": [
		'Ask Kudi. You can ask Kudi in any of these ways or similar:',
		'I need airtime',
		'Buy me 500 airtime',
		'Send airtime to 080333333...'
	],
	"Charge": 'FREE!'
};


export const VGCWATER = {
    "Title": "VGC Water Bill Payment", 
    "Description": "You can pay your VGC water bill by texting Kudi. All you need is your Client ID or Meter Number. To complete your first payment it requires a one-time login with your phone number after which subsequent transactions are seamless.",
    "How": [
	'Ask Kudi. You can ask Kudi in any of these ways or similar:',
    'vgc',
    'pay vgc water',
    'pay vgc'
    ],
	"Charge": 'None'
};

export const DEMOSCHOOL = {
    "Title": "Demo School Fees Payment",
    "Description": "You can pay your fees for Demo Comprehensive high school by texting Kudi. All you need is the Student Registration Number. For your first payment you need to provide your phone number for a one-time verification.",
    "How": [
		'Ask Kudi. You can ask Kudi in any of these ways or similar:',
        'Pay demoschool fees',
        'demo school',
        'pay demo school fees'
    ],
    "Charge": 'There is a service charge of 100 naira.'
};

export const JUNGLEJUSTICE = {
    "Title": "Jungle Justice Ticket",
    "Description": "You can buy your Jungle Justice tickets by texting Kudi. You simply provide your email address and phone number for a one-time verification.",
    "How": [
		'Ask Kudi. You can ask Kudi in any of these ways or similar:',
        'Pay for jungle justice',
        'jungle justcie',
        'ayo afolabi tickets'
    ],
    "Charge": 'There is a service charge of 70NGN for VIP tickets and 50NGN for Regular tickets.'
};


// WEBPACK FOOTER //
// ./src/modules/routes/route-data.js